var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"size":"small","placeholder":"请选择"},on:{"change":_vm.change},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }